import Operation from './Operation.js';
import InsertEvent from './InsertEvent.js';

class PasteEvents extends Operation {
    constructor(mix, events, stepNumber) {
        super(mix, events[0].getType());

        this.eventsToPaste = events;
        this.stepNumber = stepNumber;
    }

    insertEvent(event, duration) {
        new InsertEvent(this.mix, event, duration)
            .execute();
    }

    execute() {
        let firstPosition = this.eventsToPaste[0].step;

        for (let i in this.eventsToPaste) {
            let event = this.eventsToPaste[i];
            event.step = event.step - firstPosition + this.stepNumber;
            this.insertEvent(event, event.duration);
        }
    }
}

export default PasteEvents;
